import React, { useState } from "react";
import { StyledCardStack } from "./styles";
import classNames from "classnames";
import { DISCORD_LINK } from "../../Utils";

const number_of_cards = 4;
const Sudowrite101Card = (
  //use &nbsp; between penultimate and last words to prevent widows - a typography issue where a word appears on a line by itself.
  <li className="card">
    <h3 className="primary">Sudowrite 101 - Live Class</h3>
    <p>
      Join one of our author-led classes and get up to speed&nbsp;quickly!
      <br />
      New classes every week
      <br />
      {"->"} Free to all Sudowrite users
      <br />
      {"->"} Space is limited, please register
    </p>
    <a className="primary" href="https://lu.ma/sudowrite/?utm_source=EDU_cards" target="_blank" rel="noreferrer">
      Register {"->"}
    </a>
  </li>
);

const OfficeHoursCard = (
  <li className="card">
    <h3 className="primary">Live help - Classes & Author&nbsp;Hours</h3>
    <p>
      Join our live classes and author hours for help at every level.
      <br />
      New sessions every week.
      <br />
      {"->"} Included with your Sudowrite membership
    </p>
    <a className="primary" href="https://lu.ma/sudowrite?utm_source=EDU_cards" target="_blank" rel="noreferrer">
      Register {"->"}
    </a>
  </li>
);

const PinnedResourceCards = [
  <li className="card">
    <h3 className="orange">Join our Community</h3>
    <p>Connect with a friendly community of forward-thinking authors, writers & AI enthusiasts. Experiment, learn, and share!</p>
    <a className="orange" href={DISCORD_LINK} target="_blank" rel="noreferrer">
      Join {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow2">Read the Manual</h3>
    <p>Learn how each of Sudowrite's many features work.</p>
    <a className="rainbow2" href="https://docs.sudowrite.com/getting-started/dQph1snuwbfMWG9wRjsNug/quick-start/2A4FjtiocrtxHPUyz6WZgR" target="_blank" rel="noreferrer">
      Read more {"->"}
    </a>
  </li>,
<li className="card">
    <h3 className="rainbow3">Subscribe to our YouTube Channel</h3>
    <p>We post new features launches, course recordings, and tips & tricks!</p>
    <a className="rainbow3" href="https://www.youtube.com/@sudowrite4400" target="_blank" rel="noreferrer">
      Go {"->"}
    </a>
  </li>
];

const otherCards = [
  //add a new card (<li></li> tags demark the beginning and end) which will be pulled randomly from this list and shown to all users, separated by a comma
  <li className="card">
    <h3 className="orange">Use Visualize and Describe to Bring Characters to&nbsp;Life</h3>
    <a href="https://www.youtube.com/watch?v=JwSHnRLFqUA" target="_blank" rel="noreferrer">
      <img src="/assets/Visualize_Describe_Youtube_Thumbnail.png" />
    </a>
    <a className="orange" href="https://www.youtube.com/watch?v=JwSHnRLFqUA" target="_blank" rel="noreferrer">
      Watch on Youtube {"->"}
    </a>
  </li>,
  // <li className="card">
  //   <h3 className="rainbow1">Rewrite in the style of a famous&nbsp;author</h3>
  //   <p>You’ve got a scene that needs some creepy/ominous vibes, but you usually write romance. Ask Stephen King for help! Here’s&nbsp;how…</p>
  //   <a className="rainbow1" href="https://www.notion.so/sudowrite/Sudowrite-Manual-a7f14fca0aa14035bc84b04c35d93b14#bae3b86f805c4e9ba32b47679b77f9ce" target="_blank" rel="noreferrer">
  //     Keep reading {"->"}
  //   </a>
  // </li>,
  <li className="card">
    <h3 className="rainbow3">See what's new on the&nbsp;Changelog</h3>
    <p>We're constantly improving Sudowrite. Catch up on the latest features and upgrades.</p>
    <a className="rainbow3" href="https://feedback.sudowrite.com/changelog/" target="_blank" rel="noreferrer">
      Go {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow3">How to change tenses,&nbsp;automatically</h3>
    <p>You're halfway through your chapter and you realize it's gotta be in past, not present tense. Here's what you&nbsp;do…</p>
    <a className="rainbow3" href="https://blog.sudowrite.com/change-from-one-tense-to-another-tense-automatically/" target="_blank" rel="noreferrer">
      Keep reading {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow4">Instant Dialogue, wherever you need&nbsp;it</h3>
    <p>You’ve got a dialogue-less, description-heavy piece that’s just begging for some conversation…but you hate writing dialogue. Here’s a quick way to incorporate conversations relevant&nbsp;to</p>
    <a className="rainbow4" href="https://blog.sudowrite.com/adding-dialog-to-description-heavy-writing/" target="_blank" rel="noreferrer">
      Keep reading {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow5">Richer Character Descriptions with&nbsp;Sudowrite</h3>
    <p>Helping your reader visualize your characters is key to immersing them in your story. Here’s how we do it in&nbsp;Sudowrite.</p>
    <a className="rainbow5" href="https://blog.sudowrite.com/creating-character-descriptions/" target="_blank" rel="noreferrer">
      Keep reading {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="red">Complete, detailed outlines in 3 minutes&nbsp;flat</h3>
    <p>
      Whether you’re a planner or a pantser, having some idea of where you’re going can be helpful. But writing an exhaustively detailed and cohesive outline is hard. Here’s how Sudowrite makes
      it&nbsp;easy…
    </p>
    <a className="red" href="https://blog.sudowrite.com/use-well-known-outline-techniques-with-sudowrite/" target="_blank" rel="noreferrer">
      Keep reading {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow2">💡 Quick tip:</h3>
    <p>Want to tell Sudowrite what to write next in the story? Use Guided Write. Just click the ▼ next to the Write&nbsp;button.</p>
  </li>,
  <li className="card">
    <h3 className="rainbow1">💡 Quick tip:</h3>
    <p>Want Write to write…less? (Or more?) Just click the ▼ next to the Write button and click Write&nbsp;Settings…</p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">💡 Quick tip:</h3>
    <p>Rainbow background not your thing? 🚫🌈 Click the gear in the top right and you can choose from one of several&nbsp;themes!</p>
  </li>,
  <li className="card">
    <h3 className="orange">💡 Quick tip:</h3>
    <p>Join our Discord Community and learn from other writers using&nbsp;Sudowrite!</p>
    <a className="orange" href={DISCORD_LINK} target="_blank" rel="noreferrer">
      Go {"->"}
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Scraps File: Keep For Later</h3>
    <p>Create a SCRAPS document to save inspiring snippets for later!</p>
    <img src="/assets/edu/scraps.png" />
  </li>,
  <li className="card">
    <h3 className="rainbow3">AI Beta Readers</h3>
    <p>
      Want feedback on a chapter? Turn on <strong>Feedback</strong> in Labs. Then highlight a passage, click{" "}
      <nobr>
        <strong>More ▼</strong>
      </nobr>
      , then <strong>Feedback</strong>.
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Rewrite: Add More dialogue</h3>
    <p>
      Highlight a section with at least 2 named characters and click <strong>Rewrite</strong>. Choose <strong>Custom</strong> and then type in "add in more dialogue."
    </p>
  </li>,

  <li className="card">
    <h3 className="rainbow3">💡 Quick tip</h3>
    <p>
      <strong>First Draft</strong> works best with a genre in the prompt! Like this:
      <br />
      <br />
      <em>
        Write a <strong>time travel science fiction</strong> story where a woman is transported to London in 1536.
      </em>
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">When Prompting...</h3>
    <p>
      Avoid pronouns for better results in <strong>First Draft</strong>, <strong>Guided Write</strong>, and <strong>Expand</strong>. Name the characters, objects, and settings, instead of using he,
      she, it, or they.
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">How to keep Write on task</h3>
    <p>
      Direct ✨ <strong>Auto Write</strong> by adding <strong>Key Details</strong> under <strong>Write Settings</strong>. ✨ <strong>Auto Write</strong> reads 1,000 words above the cursor AND the
      information in <strong>Key Details</strong>.
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Get Started in Less than 10 Minutes!</h3>
    <a href="https://youtu.be/RHYkYLri0Ek">
      <img src="/assets/edu/quick_start.png" />
    </a>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Sudowrite: The Safety Net</h3>
    <p>Writers tell us Sudowrite increases writing speed even without AI! Having a “junior writer” on-hand gives writers the feeling of a safety net.</p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Shrink Ray: When You Meant to Take Notes</h3>
    <p>
      Import a manuscript and click <strong>Shrink Ray</strong> under <strong>More ▼</strong> for log lines, blurbs, synopses, and a full outline!
    </p>
  </li>,

  <li className="card">
    <h3 className="rainbow3">Instant, Royalty-Free Song Lyrics</h3>
    <p>
      Write custom song lyrics using First Draft: <br />
      <br />
      example: <em>Write lyrics to a country western break up song titled "Missing the Kissing"</em>
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">💡 Quick tip</h3>
    <p>
      Set <strong>Creativity</strong> at Least to produce expected story events, or at <strong>Most</strong> to take your story in a very unexpected direction!
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Rewrite: 💪 Strong Verbs</h3>
    <p>
      Got weak verbs? Highlight up to 200 words and click <strong>Rewrite</strong>, then <strong>Custom</strong> and type <em>“have stronger verbs.”</em>
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Rewrite: Change POV</h3>
    <p>
      Highlight a section, click <strong>Rewrite</strong>, then <strong>Custom</strong> and type <em>“be in first person point of view”</em> or <em>“be in third person point of view.”</em>
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Shortcuts</h3>
    <p>
      <strong>Bold</strong>: ⌘/Ctrl + B<br />
      <em>Italic</em>: ⌘/Ctrl + I<br />
      <span className="underline">Underline</span>: ⌘/Ctrl + U
    </p>
  </li>,
  <li className="card">
    <h3 className="rainbow3">Shortcuts</h3>
    <p>
      <strong>↩️ Undo</strong>
      <br />
      ⌘/Ctrl + Z<br />
      <strong>↪️ Redo</strong>
      <br />
      ⌘/Ctrl + Shift + Z<br />
    </p>
  </li>,
];

const numOfShownCards = 1; // only one permanently shown card
const remainingCards = number_of_cards - numOfShownCards;
const remainingCardsRandom = otherCards.sort(() => 0.5 - Math.random()).slice(0, remainingCards);

export default function EDUCards({ fullWidth, updateHideEDUCards, subscription }) {
  const ulClasses = classNames({
    "full-width": fullWidth,
  });

  const [showCards, setShowCards] = useState(true);

  if (!subscription) {
    return null;
  }

  let firstCard;

  if (!subscription.stats) {
    firstCard = Sudowrite101Card;
  } else if (subscription.stats?.months_active_subscription >= 1) {
    firstCard = OfficeHoursCard;
  } else {
    firstCard = Sudowrite101Card;
  }

  return (
    <StyledCardStack>
      <ul className={ulClasses}>
        {showCards && (
          <>
            {React.cloneElement(firstCard, { key: "firstCard" })}
            {PinnedResourceCards.map((card, i) => {
              // apply unique keys by cloning and overriding key prop
              return React.cloneElement(card, { key: i });
            })}
          </>
        )}
        {showCards && (
          <li className="hide-button">
            <button
              onClick={(e) => {
                setShowCards(false);
                updateHideEDUCards(true);
              }}
            >
              Don't show these again
            </button>
          </li>
        )}
      </ul>
    </StyledCardStack>
  );
}
